import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/buttons';
import { useTheme } from 'hooks/theme';

import { ScErrorBlock, ScErrorBlockProps } from './styled';

import errorPageBg from 'assets/images/backgrounds/error-page-bg.jpg';
import { ImageComponent } from 'components/Image';

interface ErrorBlockProps extends ScErrorBlockProps {
  withLogo?: boolean;
  text?: string;
  subText?: string | React.ReactNode;
  richText?: React.ReactNode;
  buttonText?: string;
  contactUsTexts?: string;
  handleOpenSupport?: () => void;
}

export const ErrorBlock: FC<ErrorBlockProps> = ({
  text,
  subText,
  richText,
  buttonText,
  withBg,
  withLogo,
  contactUsTexts,
  handleOpenSupport,
}) => {
  const { t } = useTranslation('common');
  const { menu } = useTheme();

  return (
    <ScErrorBlock withBg={withBg}>
      {withBg && (
        <ImageComponent fill className="page-bg" src={errorPageBg} alt="#" />
      )}
      {text && <p className="title">{text}</p>}
      {subText &&
        (typeof subText === 'string' ? (
          <p className="subtitle">{subText}</p>
        ) : (
          subText
        ))}

      {richText && (
        <div className="rich-text">
          {withLogo && <menu.logo.component />}
          {richText}
        </div>
      )}

      {(handleOpenSupport || buttonText) && (
        <div className="buttonWrap">
          {handleOpenSupport && (
            <Button whiteTransparent xLarge onClick={handleOpenSupport}>
              {t('glossary:contactUs')}
            </Button>
          )}
          {contactUsTexts && (
            <Button
              xLarge
              whiteTransparent
              href="mailto:support@luckyelfcasino.com"
            >
              {contactUsTexts}
            </Button>
          )}
          {buttonText && (
            <Button xLarge blue to="/">
              {buttonText}
            </Button>
          )}
        </div>
      )}
    </ScErrorBlock>
  );
};
